export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./events-list.vue?vue&type=template&id=7373bb08&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-list/events-list.vue?vue&type=template&id=7373bb08&
// module id = 944
// module chunks = 0